import { ApiService, ApiZones } from './api.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class RefererInterceptor implements HttpInterceptor {
  constructor(private apiService: ApiService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const usVertical = ['us_security', 'udavinci','unimiami'];
    const zone = usVertical.some(domain => req.url.includes(domain)) ? ApiZones.US : ApiZones.EU;

    const refererUrl = zone === ApiZones.US
      ? 'https://backoffice_us.mylxp.ai/'
      : 'https://backoffice.mylxp.ai/';

    const modifiedReq = req.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Referer': refererUrl
      }
    });

    return next.handle(modifiedReq);
  }
}
